/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ManualEnumerationInputDto
 */
export interface ManualEnumerationInputDto {
    /**
     * 
     * @type {number}
     * @memberof ManualEnumerationInputDto
     */
    enumerationOptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualEnumerationInputDto
     */
    $type?: ManualEnumerationInputDtoTypeEnum;
}


/**
 * @export
 */
export const ManualEnumerationInputDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoManualEnumerationInputDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManualEnumerationInputDtoTypeEnum = typeof ManualEnumerationInputDtoTypeEnum[keyof typeof ManualEnumerationInputDtoTypeEnum];



/**
 * Check if a given object implements the ManualEnumerationInputDto interface.
 */
export function instanceOfManualEnumerationInputDto(value?: unknown): value is ManualEnumerationInputDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManualEnumerationInputDtoTypeEnum)[0];
}

export function ManualEnumerationInputDtoFromJSON(json: any): ManualEnumerationInputDto {
    return ManualEnumerationInputDtoFromJSONTyped(json, false);
}

export function ManualEnumerationInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualEnumerationInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enumerationOptionId': json['enumerationOptionId'] == null ? undefined : json['enumerationOptionId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ManualEnumerationInputDtoToJSON(value?: ManualEnumerationInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'enumerationOptionId': value['enumerationOptionId'],
        '$type': value['$type'],
    });
}

